<template>
  <sui-card class="state-card">
    <sui-card-content class="compact">
      <b>Remote access</b>
    </sui-card-content>
    <sui-card-content :title="service.remoteAccess ? 'Disable' : 'Enable'">
      <i class="globe huge fitted icon" :class="service.remoteAccess ? 'blue' : 'grey disabled'" />
      <b>{{service.remoteAccess ? 'Enabled' : 'Disabled' }}</b>
      <span class="aside ports" :class="{compact: ports.length > 7}">
        <sui-button class="port" attached="right" size="mini" v-for="(port, index) in ports" :key="index" title="Service port">
          <span class="protocol">{{port.protocol}}</span>:{{port.value}}
        </sui-button>
      </span>
      <span class="aside edges" :class="{compact: edges.length > 5}">
        <router-link class="ui left attached button edge" :to="`/services/${servicesById[edgeId].name}`" v-for="edgeId in edges" :key="edgeId" title="Open edge service" data-goal="SERVICE_PAGE_EDGE_OPEN">
          <Logo inline :entity="servicesById[edgeId]" />{{servicesById[edgeId].name}}
        </router-link>
      </span>
    </sui-card-content>
    <sui-button-group class="fluid" size="mini" attached="bottom">
      <sui-button icon="cog" :disabled="isDisabled" @click.prevent="$modals.updateService.open(service, 'updatingRemoteAccess')" data-goal="SERVICE_PAGE_REMOTEACCESS_EDIT" />
      <sui-dropdown ref="actions" :class="{disabled: isEndpointsDisabled}" button text="Endpoints" icon="dropdown">
        <sui-dropdown-menu>
          <p :class="{disabled: !servicesById[id].remoteAccess && !service.remoteAccess, offline: servicesById[id].status !== 'ONLINE'}" v-for="(endpoints, id) in endpointsById" :key="id">
            <b><Logo inline :entity="servicesById[id]" />{{servicesById[id].name}}</b><br>
            <span v-show="endpoints.length">
              <a v-for="endpoint in endpoints" :key="endpoint" :href="endpoint" target="_blank">
                {{endpoint}}
              </a>
            </span>
            <span v-show="!endpoints.length">
              No endpoints
            </span>
          </p>
        </sui-dropdown-menu>
      </sui-dropdown>
    </sui-button-group>
  </sui-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'ServiceRemoteAccessCard',
    props: {
      service: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['actionsById', 'servicesById']),
      actions() {
        return this.actionsById[this.service.id]
      },
      edges() {
        return this.service._edges.map(service => service.id)
      },
      endpointsById() {
        if (!this.service.services || !this.service.services.length) {
          return this.service._endpointsById
        }
        if (this.service.services && this.service.services.length) {
          return this.service._edgepointsById
        }
        return {}
      },
      endpointsCount() {
        return Object.values(this.endpointsById).reduce((a, b) => a.concat(b), []).length
      },
      ports() {
        return this.service.ports
      },
      isDeployed() {
        return this.service._isDeployed
      },
      inProgress() {
        return this.service._inProgress
      },
      isOffline() {
        return this.service._isOffline
      },
      isDisabled() {
        return this.inProgress || !this.isDeployed || !this.actions.serviceUpdate
      },
      isEndpointsDisabled() {
        return !this.isDeployed || this.isOffline || !this.endpointsCount
      },
    },
    methods: {
      setRemoteAccess(remoteAccess) {
        if (this.isDeployed && !this.inProgress) {
          return this.$modals.confirm.open({
            text: `You are going to ${remoteAccess ? 'enable' : 'disable'} remote access of the service.`,
            callback: () => {
              this.service.update({remoteAccess}).catch(error => {
                this.$emit('error', error.message)
              })
            },
          })
        }
      },
    },
  }
</script>

<style scoped>
  .content { overflow: hidden; }
  .aside { position: absolute; top: 5%; max-height: 90%; display: flex; flex-direction: column; }
  .aside .button { flex-shrink: 1; padding: .3em!important; white-space: nowrap; }

  .edges { right: 0; z-index: 1; align-items: flex-end; }
  .edge { transform: translate(100%)!important; margin-right: 2.1em!important; font-size: .9em!important; transition: all .3s!important; }
  .edge:hover { transform: translate(0)!important; margin-right: 0!important; }
  .aside.compact .edge { font-size: .8em!important; }

  .ports { left: 0; z-index: 1; align-items: flex-start; }
  .port { margin-left: -2em!important; font-family: monospace!important; font-size: .9em!important; transition: all .3s!important; }
  .port:hover { margin-left: 0!important; }
  .aside.compact .port { font-size: .8em!important; }

  .dropdown { text-align: center!important; }

  .menu { padding: .7em 2em .7em .7em!important; max-height: 20em; overflow: auto; font-size: 1.2em!important; font-weight: normal; }
  .menu a { display: block; }
  .menu p:not(:last-child) { margin: 0 0 .3em; }
  .menu p.disabled, .menu p.offline { pointer-events: none; opacity: .5; }
  .menu p.disabled b:after { content: ' (without remoteAccess)' }
  .menu p.offline b:after { content: ' (offline)' }
</style>
